import Table from "components/Table/Table";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { setIsLoading, setValidationState } from "reducers/main";
import {
  useGetClaimByIdQuery,
  useGetClaimTransmissionHistoryQuery,
  useGetClaimValidationsQuery,
} from "services/claims-api";
import { setClaimsFormData, setCurrentClaim } from "services/claimsDataSlice";
import type {
  ClaimsDataType,
  ClaimsTransmissionHistoryType,
} from "types/DataTypes";
import { useDispatch } from "utils/redux";

import ClaimsPageContainer from "./ClaimsPageContainer";

const CLAIMS_TRANSMISSION_HISTORY_COLUMNS = [
  { key: "date", name: "Date Received" },
  { key: "type", name: "Transmission Type (Query/TIN/Claim/etc)" },
  { key: "is_historical_verbose", name: "Historical / Stubbed" },
  { key: "cms_disposition_code", name: "Disposition Code" },
  { key: "applied_error_codes", name: "Error Codes" },
  { key: "applied_compliance_flags", name: "Compliance Flags" },
];

const ClaimsTransmissionHistory = () => {
  const dispatch = useDispatch();
  const { claimId } = useParams<{ claimId?: string }>();

  const { data, isLoading } = useGetClaimTransmissionHistoryQuery(
    { id: claimId },
    { skip: !claimId },
  );

  const { data: claimValidation } = useGetClaimValidationsQuery(
    { id: claimId },
    { skip: !claimId },
  );

  const { data: claim, isLoading: isClaimLoading } = useGetClaimByIdQuery<{
    data: ClaimsDataType;
    isLoading: boolean;
  }>({ id: claimId }, { skip: !claimId });

  useEffect(() => {
    if (!isClaimLoading) {
      dispatch(setClaimsFormData(claim));
      dispatch(setCurrentClaim(claim));
    }
  }, [dispatch, isClaimLoading]);

  useEffect(() => {
    if (claimValidation) {
      dispatch(
        setValidationState({
          errors: claimValidation.filter((e) => e.level === "ERROR"),
          warnings: claimValidation.filter((e) => e.level === "WARN"),
        }),
      );
    }
  }, [claimValidation, dispatch]);

  useEffect(() => {
    dispatch(setIsLoading(isLoading));
  }, [dispatch, isLoading]);

  return (
    <ClaimsPageContainer>
      <Table
        columns={CLAIMS_TRANSMISSION_HISTORY_COLUMNS}
        rows={data || []}
        rowKeyGetter={(row: ClaimsTransmissionHistoryType) => row.id}
      />
    </ClaimsPageContainer>
  );
};

export default ClaimsTransmissionHistory;
